import { Pipe, PipeTransform } from '@angular/core';
import { CommonNumberWithUnitsFormatterPipe } from './common_number_with_units_formatter.pipe';

@Pipe({
	name: 'commonPercentFormatter',
})
export class CommonPercentPipe implements PipeTransform {
	constructor (
		private commonNumberWithUnitsFormatter: CommonNumberWithUnitsFormatterPipe,
	) {}
	transform (data: any): string {
		return this.commonNumberWithUnitsFormatter.transform(data, '%');
	}
}
